<template>
  <div class="modal_dim on"><!--'on 추가'-->
    <div class="modal_wrap">
      <div class="modal_inner center w1200">
        <div class="modal w50p">
          <div class="modal_head">
            <h1 class="h1">
              <span>아이디 찾기</span>
            </h1>
          </div>
          <div class="modal_con">
            <div class="modal_txt">
              <p><b>{{ data.userId }}</b></p>
            </div>
          </div>
          <div class="modal_btn">
            <div class="btn_wrap">
              <button class="btn bo grey" @click="fnPage(1)">확인</button>
              <button class="btn" @click="fnPage(2)">비밀번호 찾기</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'modal-find-id-result',
  description: '아이디 찾기 결과 모달',
  props: {
    data: {
      type: [Array, Object],
      default: () => {}
    },
    callBack: {
      type: [Function]
    }
  },
  methods: {
    fnPage: function(type = 1) {
      if(type === 1) {
        this.$router.push({ path: '/sign/in' })
      } else {
        this.$router.push({ path: '/sign/find/password/step1'})
      }
    }
  }
}
</script>

<style scoped>

</style>
